import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "@/utils/apiClient";
import { useAuth } from "@/state/auth";

export interface ModelSettings {
  chatModel: string;
  embeddingModel: string;
  temperature: number;
  streaming: boolean;
  markdownEnabled: boolean;
  updatedAt: string | null;
  updatedBy: string | null;
}

export const useModelSettings = () => {
  const profile = useAuth((state) => state.profile);
  return useQuery({
    queryKey: ["admin", "model-settings"],
    queryFn: async () => {
      const { config } = await apiRequest<{ config: ModelSettings }>("/api/admin/models/config");
      return config;
    },
    staleTime: 5 * 60_000,
    enabled: Boolean(profile),
  });
};

export const useUpdateModelSettings = () => {
  const profile = useAuth((state) => state.profile);
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: {
      chatModel: string;
      embeddingModel: string;
      temperature: number;
      streaming: boolean;
      markdownEnabled: boolean;
    }) => {
      const body = {
        chat_model: payload.chatModel,
        embedding_model: payload.embeddingModel,
        temperature: payload.temperature,
        streaming: payload.streaming,
        markdown_enabled: payload.markdownEnabled,
      };
      const { config } = await apiRequest<{ config: ModelSettings }>("/api/admin/models/config", {
        method: "PUT",
        body: JSON.stringify(body),
      });
      return config;
    },
    onSuccess: () => {
      if (profile) {
        queryClient.invalidateQueries({ queryKey: ["admin", "model-settings"] });
      }
    },
  });
};
